import { state } from '../core/state.js';
import { $, $$, esc } from '../core/text.js';
import { checkAchievements, renderCurrency, saveProgress } from '../progress/xp.js';
import { mitLadezustand } from '../ui/busy.js';
import {
  block, fehlerBox, ladend, linie, skelPersonen, wireErneut, wrap,
  zeigeInhalt, zeigeSkeleton,
} from '../ui/skeleton.js';
import { pushPop, toast } from '../ui/toast.js';
import { cloudFriendRemove, cloudFriendReq, cloudFriendRespond, cloudFriends, cloudInvite, cloudInviteClaim, cloudSearchUsers, cloudSetUsername, refreshSocial } from './api.js';
import { challengeCreateModal, renderChallenges } from './community.js';
import { publicProfileModal, uebernehmeNutzername } from './profile.js';

/* ══════════ Freunde-Ansicht ══════════ */
let frSearchTimer = null;
/* Entprellte Freundesuche – der Timer bleibt in diesem Modul, damit ihn
   niemand von außen überschreiben muss. */
export function scheduleFriendSearch(delay = 300) {
  clearTimeout(frSearchTimer);
  frSearchTimer = setTimeout(runFriendSearch, delay);
}
export async function renderFriends() {
  $('#friends-need').classList.add('hidden'); $('#friends-body').classList.remove('hidden');
  if ($('#fr-username') && document.activeElement !== $('#fr-username')) $('#fr-username').value = state.me?.username || '';

  /* Die Liste stand vorher komplett leer, bis die Antwort da war – und der
     Zähler zeigte solange nichts. Jetzt deuten drei Zeilen an, was kommt.
     Die Panels selbst (Überschriften, Suchfeld, Einladungscode) stehen
     sofort: sie hängen an keinen Daten. */
  zeigeSkeleton($('#fr-friends'), skelPersonen(3));
  let data = null;
  try { data = await cloudFriends(); }
  catch (e) {
    /* Offline war hier vorher stillschweigend „keine Freunde". Das ist eine
       Aussage über andere Menschen, die wir gerade nicht treffen können. */
    const box = $('#fr-friends');
    zeigeInhalt(box, fehlerBox('Deine Freundesliste konnte nicht geladen werden: ' + e.message));
    wireErneut(box, () => renderFriends());
    renderChallenges();
    renderInvite();
    return;
  }
  $('#fr-count').textContent = data.friends.length;
  $('#fr-incoming-count').textContent = data.incoming.length || '';
  $('#fr-incoming-panel').style.display = data.incoming.length ? '' : 'none';
  zeigeInhalt($('#fr-friends'), data.friends.length
    ? data.friends.map((u) => friendRow(u, 'friend')).join('')
    : `<p class="page-sub">Noch keine Freund:innen. Such oben nach einem Nutzernamen.</p>`);
  $('#fr-incoming').innerHTML = data.incoming.map((u) => friendRow(u, 'incoming')).join('');
  $('#fr-outgoing-wrap').style.display = data.outgoing.length ? '' : 'none';
  $('#fr-outgoing').innerHTML = data.outgoing.map((u) => friendRow(u, 'outgoing')).join('');
  wireFriendRows();
  renderChallenges();
  renderInvite();
}
export async function renderInvite() {
  const box = $('#fr-invite'); if (!box) return;
  zeigeSkeleton(box, wrap(`<div class="skel-row">${block('132px', '34px', '10px')}${block('96px', '30px', '999px')}</div>${linie('58%', '.8em')}`));
  try {
    ladend(box, false);
    const inv = await cloudInvite();
    box.innerHTML = `<div class="invite-code-row">
        <code class="invite-code" id="invite-code">${esc(inv.code)}</code>
        <button class="btn-ghost outline tiny" id="invite-copy">Kopieren</button>
      </div>
      <p class="page-sub" style="margin-top:8px">Bereits eingeladen: <b>${inv.invited}</b> ${inv.invited === 1 ? 'Person' : 'Personen'} 🎉</p>`;
    $('#invite-copy').onclick = async () => {
      try { await navigator.clipboard.writeText(inv.code); toast('Code kopiert ✦'); }
      catch { toast('Code: ' + inv.code); }
    };
    // ausstehende Diamanten gutschreiben
    if (inv.unclaimedGems > 0) {
      try {
        const { gems } = await cloudInviteClaim();
        if (gems > 0) { state.progress.gems += gems; await saveProgress(); renderCurrency(); pushPop({ img: 'assets/icon_gem.png', eyebrow: 'Einladung belohnt!', name: 'Freund:innen geworben', reward: `+${gems} 💎` }); }
      } catch { /* später erneut */ }
    }
  } catch (e) {
    zeigeInhalt(box, fehlerBox('Der Einladungscode konnte nicht geladen werden.'));
    wireErneut(box, () => renderInvite());
  }
}
export function friendRow(u, kind) {
  const av = `<span class="fr-av">${(u.username || '?')[0].toUpperCase()}</span>`;
  const open = `<button class="fr-open" data-uid="${u.id}" title="Profil ansehen">${av}<span class="fr-name">${esc(u.username || 'Unbekannt')}</span></button>`;
  let btns = '';
  if (kind === 'friend') btns = `<button class="btn-ghost outline tiny fr-duel" data-id="${u.id}" data-name="${esc(u.username || '')}">⚔ Duell</button><button class="btn-ghost outline tiny fr-remove" data-id="${u.id}">Entfernen</button>`;
  else if (kind === 'incoming') btns = `<button class="btn-primary tiny fr-accept" data-id="${u.id}">Annehmen</button><button class="btn-ghost outline tiny fr-decline" data-id="${u.id}">Ablehnen</button>`;
  else if (kind === 'outgoing') btns = `<span class="fr-pending">ausstehend</span><button class="btn-ghost outline tiny fr-remove" data-id="${u.id}">Zurückziehen</button>`;
  else if (kind === 'search') {
    const map = { none: `<button class="btn-primary tiny fr-add" data-id="${u.id}">+ Freund</button>`, outgoing: `<span class="fr-pending">angefragt</span>`, incoming: `<button class="btn-primary tiny fr-accept" data-id="${u.id}">Annehmen</button>`, friends: `<span class="fr-pending">befreundet ✓</span>` };
    btns = map[u.rel] || '';
  }
  return `<div class="fr-row">${open}<span class="fr-btns">${btns}</span></div>`;
}
export function wireFriendRows() {
  const act = async (fn, ok) => { try { await fn(); await refreshSocial(); await checkAchievements(); renderFriends(); if (ok) toast(ok); } catch (e) { toast(e.message); } };
  $$('#friends-body .fr-open').forEach((b) => b.onclick = () => publicProfileModal(b.dataset.uid));
  $$('#friends-body .fr-add').forEach((b) => b.onclick = () => act(() => cloudFriendReq(b.dataset.id), 'Anfrage gesendet ✦').then(() => runFriendSearch()));
  $$('#friends-body .fr-accept').forEach((b) => b.onclick = () => act(() => cloudFriendRespond(b.dataset.id, true), 'Freund:in hinzugefügt ✦'));
  $$('#friends-body .fr-decline').forEach((b) => b.onclick = () => act(() => cloudFriendRespond(b.dataset.id, false)));
  $$('#friends-body .fr-remove').forEach((b) => b.onclick = () => act(() => cloudFriendRemove(b.dataset.id)));
  $$('#friends-body .fr-duel').forEach((b) => b.onclick = () => challengeCreateModal(b.dataset.id, b.dataset.name));
}
export async function runFriendSearch() {
  const q = $('#fr-search')?.value.trim() || '';
  const box = $('#fr-search-res');
  if (q.length < 2) { zeigeInhalt(box, ''); return; }
  // Zwei Zeilen: genug als Zeichen, dass gesucht wird, ohne eine Trefferzahl
  // vorzutäuschen, die noch niemand kennt.
  zeigeSkeleton(box, skelPersonen(2));
  try {
    const { users } = await cloudSearchUsers(q);
    zeigeInhalt(box, users.length ? users.map((u) => friendRow(u, 'search')).join('') : `<p class="page-sub">Niemand gefunden.</p>`);
    $$('#fr-search-res .fr-add').forEach((b) => b.onclick = async () => { try { await cloudFriendReq(b.dataset.id); toast('Anfrage gesendet ✦'); runFriendSearch(); renderFriends(); } catch (e) { toast(e.message); } });
    $$('#fr-search-res .fr-accept').forEach((b) => b.onclick = async () => { try { await cloudFriendRespond(b.dataset.id, true); await refreshSocial(); await checkAchievements(); toast('Freund:in hinzugefügt ✦'); runFriendSearch(); renderFriends(); } catch (e) { toast(e.message); } });
  } catch (e) {
    zeigeInhalt(box, fehlerBox('Die Suche hat nicht geklappt: ' + e.message));
    wireErneut(box, () => runFriendSearch());
  }
}
export async function saveUsername(btn) {
  const v = $('#fr-username').value.trim();
  const st = $('#fr-username-status');
  try {
    const r = await mitLadezustand(btn, () => cloudSetUsername(v));
    // Zieht den Anzeigenamen mit, solange er nur abgeleitet war.
    await uebernehmeNutzername(r.user.username);
    st.textContent = '✓ Gespeichert – andere finden dich jetzt als „' + r.user.username + '".'; st.className = 'status ok';
  } catch (e) { st.textContent = e.message; st.className = 'status err'; }
}

